export default "__VITE_ASSET__DRDDce3___"